<template>
  <div class="my-layout-box">
    <list-view
      :getList="getList"
      :isTabsShow="isTabsShow"
      :isButtonShow="isButtonShow"
      :buttonList="buttonList"
      :listMap="listMap"
      :placeholderTitle="placeholderTitle"
      @onSeeDetail="onSeeDetail"
    >
    </list-view>
  </div>
</template>

<script>
import listView from "~/components/List/ListView.vue";
import { itemsData } from "./config";
import { getOrderContract } from "~/api/finance";
export default {
  name: "OrderBalanceView",
  components: {
    listView
  },
  data() {
    return {
      isTabsShow: false,
      isButtonShow: true,
      listMap: itemsData,
      placeholderTitle: "请输入订单号",
      buttonList: [
        {
          title: "查看详情"
        }
      ]
    };
  },

  methods: {
    async getList(pagination, searchData) {
      let sendData = {
        page: pagination.page,
        limit: pagination.size
      };
      sendData.AgentOrderNos = searchData.value;
      const list = await getOrderContract(sendData);
      list.Items.forEach((item, index) => {
        item.SignStatus = item.SignFlowSigned != null ? "已签署" : "未签署";
      });
      const data = {
        List: list.Items,
        Total: list.Total
      };
      return data;
    },
    onSeeDetail(items) {
      const { Id } = items;
      this.$router.push({
        name: "orderContractDetail",
        query: {
          id: Id
        }
      });
    }
  }
};
</script>

<style lang="less" scope></style>
